import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import type { FC } from "react";
import { TopUserInfoBlock } from "./user-info/TopUserInfoBlock";
import { DownRightsPayBlock } from "./user-info/DownRightsPayBlock";
import { MyGalleryBlock } from "./user-info/MyGalleryBlock";

type UserPageProps = {
  user: any;
  onPaySuccess: () => void;
  showPromptMsg: (msg: string) => void;
};

// show it after user login
export const UserPage: FC<UserPageProps> = ({
  user,
  onPaySuccess,
  showPromptMsg,
}) => {
  // responsive UI
  const theme = useTheme();
  const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid container spacing={2} id="user-page" sx={{ marginTop: "16px" }}>
      {/* 淡化背景图片 */}
      <Grid
        size={{ xs: 12 }}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "99%",
          backgroundColor: "rgba(255, 255, 255, 0.6)",
        }}
      ></Grid>

      {/* 右边栏 - 用户信息 和 会员权限介绍 */}
      <Grid size={{ xs: 12, sm: 4 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: notPhone ? "calc(100vh - 130px)" : "auto",
            width: "100%",
            gap: "32px",
          }}
        >
          <TopUserInfoBlock userInfo={user} />
          <DownRightsPayBlock
            onPaySuccess={onPaySuccess}
            showPromptMsg={showPromptMsg}
          />
        </Box>
      </Grid>

      {/* 左边栏 - 用户魔法图历史 */}
      <Grid size={{ xs: 12, sm: 8 }}>
        <MyGalleryBlock showPromptMsg={showPromptMsg} />
      </Grid>
    </Grid>
  );
};
